import { useState } from "react";
import { ChevronDown, Globe } from "lucide-react";
import { useLang, LANG_LABELS, LANG_SHORT, type Lang } from "../i18n";

const LANGS: Lang[] = ["ru", "kk", "en"];

export function LangSwitcher() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((p) => !p)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        className="inline-flex items-center gap-1.5 rounded-full px-3 py-2.5 text-xs font-bold uppercase tracking-wider transition-colors"
        style={{
          color: "var(--fg-soft)",
          border: "1px solid var(--line)",
          background: "transparent",
        }}
        aria-label="Сменить язык"
      >
        <Globe className="h-3.5 w-3.5" aria-hidden />
        <span>{LANG_SHORT[lang]}</span>
        <ChevronDown className="h-3 w-3" aria-hidden />
      </button>

      {open ? (
        <div
          className="absolute right-0 top-full z-50 mt-2 min-w-[150px] overflow-hidden rounded-2xl"
          style={{
            background: "var(--bg-elev)",
            border: "1px solid var(--line-strong)",
            boxShadow: "0 24px 60px -16px rgba(0,0,0,0.85)",
          }}
        >
          {LANGS.map((l) => {
            const isActive = l === lang;
            return (
              <button
                key={l}
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault();
                  setLang(l);
                  setOpen(false);
                }}
                className="block w-full px-4 py-2.5 text-left text-sm transition-colors"
                style={{
                  background: isActive ? "rgba(212,166,86,0.08)" : "transparent",
                  color: isActive ? "var(--gold)" : "var(--fg)",
                  fontWeight: isActive ? 700 : 500,
                }}
              >
                <span className="mr-2 inline-block w-7 text-[10px] uppercase opacity-60">
                  {LANG_SHORT[l]}
                </span>
                {LANG_LABELS[l]}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
